import React, { useRef } from 'react';
import 'plyr-react/plyr.css'; // Import Plyr's CSS
import './VideoPlayer.css';
import Plyr from 'plyr-react';
import 'plyr-react/plyr.css';

const VideoPlayer = ({ videoUrl }) => {
    const playerRef = useRef(null);

    const playerOptions = {
        controls: [
            'play-large',
            'play',
            'progress',
            'current-time',
            'duration',
            'mute',
            'volume',
            'fullscreen',
        ],
    };

    const videoSource = {
        type: 'video',
        sources: [
            {
                src: videoUrl,
                type: 'video/mp4',
            },
        ],
    };

    const handleDoubleClick = () => {
        if (playerRef.current) {
            const player = playerRef.current.plyr;
            if (player.playing) {
                player.pause();
            } else {
                player.play();
            }
        }
    };

    return (
        <div
            style={{
                maxWidth: '504px',
                margin: '0 auto',
                borderRadius: '8px',
                overflow: 'hidden',
                marginTop: '10px',
                marginBottom: '20px',
                cursor: 'pointer',
            }}
            onDoubleClick={handleDoubleClick}
        >
            <Plyr ref={playerRef} source={videoSource} options={playerOptions} />
        </div>
    );
};

export default VideoPlayer;